import React from "react";

interface Props {
  totalProfit: number;
  totalExpenses: number;
}

function formatCurrency(value: number) {
  return `$${value.toLocaleString()}`;
}

const ProfitSummaryBoxes = ({ totalProfit, totalExpenses }: Props) => {
  const netProfit = totalProfit - totalExpenses;
  const netProfitPositive = netProfit >= 0;

  return (
    <div className="flex flex-wrap gap-4">
      <div className="flex-1 min-w-[100px] rounded-lg bg-white shadow-md py-4 px-6 text-center">
        <p className="text-xs sm:text-sm text-gray-700 font-semibold">Total Profit</p>
        <p className="text-2xl sm:text-3xl font-extrabold text-black mt-1">{formatCurrency(totalProfit)}</p>
      </div>
      <div className="flex-1 min-w-[100px] rounded-lg bg-white shadow-md py-4 px-6 text-center">
        <p className="text-xs sm:text-sm text-gray-700 font-semibold">Total Expenses</p>
        <p className="text-2xl sm:text-3xl font-extrabold text-red-600 mt-1">{formatCurrency(totalExpenses)}</p>
      </div>
      <div className={`flex-1 min-w-[100px] rounded-lg shadow-md py-4 px-6 text-center ${netProfitPositive ? 'bg-green-50' : 'bg-red-50'}`}>
        <p className="text-xs sm:text-sm text-gray-700 font-semibold">Net Profit</p>
        <p className={`text-2xl sm:text-3xl font-extrabold mt-1 ${netProfitPositive ? 'text-green-700' : 'text-red-700'}`}>{formatCurrency(netProfit)}</p>
      </div>
    </div>
  );
};

export default ProfitSummaryBoxes;